import React from 'react';
import { Link, useParams } from 'react-router-dom';

const CheckCircleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const ProgramOnboardingDonePage: React.FC = () => {
  const { programId } = useParams<{ programId: string }>();

  return (
    <div className="max-w-lg mx-auto px-4 py-16 flex flex-col items-center text-center gap-6">
      <div className="w-20 h-20 rounded-full bg-success-50 dark:bg-success-950/40 flex items-center justify-center">
        <CheckCircleIcon className="w-12 h-12 text-success-500 dark:text-success-400" />
      </div>

      <div>
        <h1 className="text-2xl font-bold text-text-primary mb-2">You're all set!</h1>
        <p className="text-text-secondary">
          You've successfully completed the program onboarding. Your learning journey starts now.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 w-full max-w-xs">
        {programId && (
          <Link
            to={`/learn/programs/${programId}`}
            className="flex-1 text-center px-4 py-2.5 rounded-full border border-border-secondary text-sm font-medium text-text-primary hover:bg-surface-secondary transition-colors text-center"
          >
            View program
          </Link>
        )}
        <Link
          to="/learn/dashboard"
          className="flex-1 text-center px-4 py-2.5 rounded-full bg-primary-600 hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 text-sm font-medium transition-colors text-center"
        >
          Go to dashboard
        </Link>
      </div>
    </div>
  );
};

export default ProgramOnboardingDonePage;
